var Breakpoints = ['XXS', 'XS', 'S', 'M', 'L', 'XL'];
export var getBreakpoints = function getBreakpoints(_ref) {
  var _ref$maxBreakpoint = _ref.maxBreakpoint,
    maxBreakpoint = _ref$maxBreakpoint === void 0 ? 'XL' : _ref$maxBreakpoint,
    _ref$minBreakpoint = _ref.minBreakpoint,
    minBreakpoint = _ref$minBreakpoint === void 0 ? 'XXS' : _ref$minBreakpoint;
  return Breakpoints.slice(Breakpoints.indexOf(minBreakpoint), Breakpoints.indexOf(maxBreakpoint) + 1);
};
export var isBreakpointLargeOrAbove = function isBreakpointLargeOrAbove(breakpoint) {
  return getBreakpoints({
    minBreakpoint: 'L'
  }).includes(breakpoint);
};
export var isBreakpointMediumOrAbove = function isBreakpointMediumOrAbove(breakpoint) {
  return getBreakpoints({
    minBreakpoint: 'M'
  }).includes(breakpoint);
};
export var isBreakpointSmallOrBelow = function isBreakpointSmallOrBelow(breakpoint) {
  return getBreakpoints({
    maxBreakpoint: 'S'
  }).includes(breakpoint);
};